import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { FlagsList } from 'ui';
import { fetchUserImage } from 'services';

const useStyles = makeStyles(theme => ({
  avatar: {
    width: 38,
    height: 38,
    marginRight: theme.spacing(1),
  },
}));

const Item = ({ id, name, position, languages }) => {
  const didUnmount = React.useRef(false);
  const [imageUrl, setImageUrl] = useState(null);
  const classes = useStyles();

  const fetchImage = async () => {
    let url = null;
    try {
      url = await fetchUserImage(id);
    } catch (e) {
      // do nothing
    } finally {
      if (!didUnmount.current) {
        setImageUrl(url);
      }
    }
  };

  useEffect(() => {
    if (id) fetchImage();
    return () => {
      didUnmount.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <ListItem>
      <Grid container spacing={1}>
        <Grid item>
          {imageUrl ? (
            <Avatar className={classes.avatar} src={imageUrl} />
          ) : (
            <Avatar className={classes.avatar}>
              <AccountCircleIcon />
            </Avatar>
          )}
        </Grid>
        <Grid item>
          <Typography variant="body1" component="h2">
            {name}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {position}
          </Typography>
          {languages && <FlagsList countryCodes={languages} />}
        </Grid>
      </Grid>
    </ListItem>
  );
};

Item.defaultProps = {
  languages: null,
};

Item.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string),
};

export { Item };
